import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
export const getUsersWaitingForInviteTranslations = value => {
  const translationKey = value > 1 ? 'upgrades.usageLimitBannerWithCustomCopy.users-waiting-for-invite.title.other' : 'upgrades.usageLimitBannerWithCustomCopy.users-waiting-for-invite.title.one';
  return {
    bannerTitleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: translationKey,
      options: {
        count: value
      }
    }),
    partialBannerSubtext: I18n.text('upgrades.usageLimitBannerWithCustomCopy.users-waiting-for-invite.subtitle')
  };
};